import { Typography } from '@atlas-metrics/design-system';
import React, { useState } from 'react';

import clsxm from '@/lib/clsxm';

import IconButton from './buttons/IconButton';

type InputType = 'text' | 'code' | 'password' | 'email';

export type InputProps = {
  name: string;
  type: InputType;
  value: string;
  placeholder: string;
  isDisabled: boolean;
  onChange: (value: string) => void;
  inputClassName?: string;
  icon?: string;
  iconClassName?: string;
  validationMsg?: string;
  onClickIconButton?: () => void;
  label?: string;
};

const Input: React.FC<InputProps> = ({
  name,
  type,
  value,
  placeholder,
  isDisabled,
  onChange,
  inputClassName,
  icon,
  iconClassName,
  onClickIconButton,
  validationMsg,
  label,
}) => {
  const [isPasswordRevealed, setIsPasswordRevealed] = useState<boolean>(false);
  return (
    <div>
      {label && (
        <span className='mb-2 flex'>
          <Typography variant='body-s' className='pl-4'>
            {label}
          </Typography>
        </span>
      )}
      <div className='relative'>
        <input
          className={clsxm(
            `h-14 w-full rounded-2xl border border-ds-grey-200 bg-white py-4 pl-4 pr-11 text-l font-medium tracking-wide text-black placeholder-ds-grey-500 outline-none placeholder:text-m placeholder:font-regular  placeholder:tracking-wide placeholder:text-ds-grey-200 hover:shadow-sm focus:border-2 focus:shadow-sm disabled:cursor-not-allowed`,
            validationMsg && 'ring-1 ring-ds-red-400',
            inputClassName
          )}
          name={name}
          type={type === 'password' && isPasswordRevealed ? 'text' : type}
          value={value}
          placeholder={placeholder}
          disabled={isDisabled}
          onChange={(e) => onChange(e.currentTarget.value)}
          data-testid='input-component'
        />
        {(icon || type === 'password') && (
          <IconButton
            className={clsxm('absolute right-2 top-1/2 -translate-y-1/2')}
            icon={
              icon ||
              (isPasswordRevealed ? 'icon-eye-blocked' : 'icon-eye-open')
            }
            onClick={() => {
              type === 'password' && setIsPasswordRevealed(!isPasswordRevealed);
              onClickIconButton && onClickIconButton();
            }}
            isGrayedOut={type === 'password' && !isPasswordRevealed}
            iconClassName={clsxm('stroke-transparent', iconClassName)}
          />
        )}
      </div>
      <Typography
        variant='body-s'
        className={clsxm('text-orange-default mx-4 mt-2 h-6 text-left')}
      >
        {validationMsg}
      </Typography>
    </div>
  );
};

export default Input;
